// src/api/users.js
// All user-related HTTP calls. Mirrors src/api/blogs.js in structure.
// See blogs.js for full rationale on why API logic is centralized here.

import axios from "axios";

const BASE = "/api/users";

// GET /api/users: fetch all users.
export async function getAllUsers() {
  const response = await axios.get(BASE);
  return response.data;
}

// GET /api/users/:id: fetch a single user by ID.
export async function getUserById(id) {
  const response = await axios.get(`${BASE}/${id}`);
  return response.data;
}

// GET /api/users/:id/blogs: fetch all blogs authored by a specific user.
// Nested resource: useful for "posts by this author" views.
export async function getUserBlogs(id) {
  const response = await axios.get(`${BASE}/${id}/blogs`);
  return response.data;
}

// POST /api/users: create a new user.
// Used by AdminDashboard in Module 9; defined now for completeness.
export async function createUser(data) {
  const response = await axios.post(BASE, data);
  return response.data;
}

// PUT /api/users/:id: update an existing user.
// Used by AdminDashboard in Module 9; defined now for completeness.
export async function updateUser(id, data) {
  const response = await axios.put(`${BASE}/${id}`, data);
  return response.data;
}

// DELETE /api/users/:id: delete a user.
// Used by AdminDashboard in Module 9; defined now for completeness.
export async function deleteUser(id) {
  const response = await axios.delete(`${BASE}/${id}`);
  return response.data;
}
